import React from 'react';
import { useHistory } from 'react-router-dom';
import { ApplicationVersion } from "~/index";
import styled from 'styled-components';

var VersionLink = styled.span`
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #1890ff;
  }
`;

var Version = function() {
  var history = useHistory();

  var handleVersionClick = function() {
    history.push('/configuracoes/versoes');
  };

  return React.createElement(VersionLink, {
    className: 'application-version',
    onClick: handleVersionClick,
  }, '© ', ApplicationVersion);
};

export default Version;
